export default (data) => {
  const base = {
    state: false,
    data: data.data ? data.data : null,
    success: !!data.success,
  };

  return base;
};
